// extracted by mini-css-extract-plugin
module.exports = {"addButton":"VideoEditingRequestsTable_addButton__2mULR","detailsModalLink":"VideoEditingRequestsTable_detailsModalLink__29qQo"};